module.exports = __webpack_public_path__ + "static/media/dashboard.8b75b5a3.svg";